import angular from 'angular'
import './wash_trades.service'

angular
  .module('admin.wash_trades', ['admin.wash_trades.service'])
  .controller('WashTradesAdminCtrl', WashTradesAdminCtrl)

/** @ngInject */
function WashTradesAdminCtrl($location, WashTradesService) {
  var vm = this
  vm.items = []
  vm.wash = {
    txt: '',
    ids: '',
    li: [],
  }

  vm.buyer_username = ''
  vm.seller_username = ''
  vm.buyer_id = ''
  vm.seller_id = $location.search() ? $location.search().seller_id : ''
  vm.username = ''
  vm.user_id = ''
  if (!vm.seller_id) {
    vm.seller_id = ''
  }

  function reloadPagination() {
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }
  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }

    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    WashTradesService.list(
      vm.oldPage,
      25,
      vm.buyer_id,
      vm.seller_id,
      vm.buyer_username,
      vm.seller_username,
      vm.username,
      vm.user_id,
    ).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var x = 0; x < result.results.length; x++) {
        var item = result.results[x].li
        for (var i = 0; i < item.length; i++) {
          switch (item[i]['cl-sell'].k) {
            case 1:
              item[i]['cl-sell'].type = 'DEPOSIT'
              break
            case 2:
              item[i]['cl-sell'].type = 'WITHDRAWAL'
              break
            case 3:
              item[i]['cl-sell'].type = 'ADMIN_ADJUSTMENT'
              break
            case 4:
              item[i]['cl-sell'].type = 'DEPOSIT_FEE'
              break
            case 5:
              item[i]['cl-sell'].type = 'WITHDRAWAL_FEE'
              break
            case 6:
              item[i]['cl-sell'].type = 'PENDING_WITHDRAWAL'
              break
            case 7:
              item[i]['cl-sell'].type = 'BUNDLE_PURCHASE'
              break
            case 8:
              item[i]['cl-sell'].type = 'WHOLE_ACCOUNT_SALE'
              break
            case 9:
              item[i]['cl-sell'].type = 'WHOLE_ACCOUNT_PURCHASE'
              break
            case 10:
              item[i]['cl-sell'].type = 'ACCOUNT_TRANSFER_FEE'
              break
            case 11:
              item[i]['cl-sell'].type = 'INITIAL_SIGNUP'
              break
            case 12:
              item[i]['cl-sell'].type = 'REWARD_INVITER'
              break
            case 13:
              item[i]['cl-sell'].type = 'REWARD_INVITEE'
              break
            case 14:
              item[i]['cl-sell'].type = 'REWARD_ADD_FACEBOOK'
              break
            case 16:
              item[i]['cl-sell'].type = 'LISTING_SALE'
              break
            case 17:
              item[i]['cl-sell'].type = 'LISTING_PURCHASE'
              break
            case 21:
              item[i]['cl-sell'].type = 'DEPOSIT_REFUND'
              break
            case 22:
              item[i]['cl-sell'].type = 'COIN_PURCHASE'
              break
            case 23:
              item[i]['cl-sell'].type = 'CRYPTO_DEPOSIT'
              break
            case 24:
              item[i]['cl-sell'].type = 'BLOCKCHAIN_TRANSACTION_FEE'
              break
            case 25:
              item[i]['cl-sell'].type = 'COIN_TO_CASH_CONVERSION'
              break
            case 26:
              item[i]['cl-sell'].type = 'STORE_CREDIT'
              break
            case 27:
              item[i]['cl-sell'].type = 'BURN_CREDITS'
              break
            case 28:
              item[i]['cl-sell'].type = 'FREE_CASH_CLAIM'
              break
          }

          switch (item[i]['cl-sell']['k-cr']) {
            case 1:
              item[i]['cl-sell'].typeCr = 'Primary Market'
              break
            case 2:
              item[i]['cl-sell'].typeCr = 'Primary and Aftermarket'
              break
            case 3:
              item[i]['cl-sell'].typeCr = 'Full Credit'
              break
          }

          item[i].ts = new Date(
            parseInt(item[i].ts.toString().substring(0, item[i].ts.toString().length - 3)),
          )
          if (item[i]['ts-m']) {
            item[i]['ts-m'] = new Date(
              parseInt(
                item[i]['ts-m'].toString().substring(0, item[i]['ts-m'].toString().length - 3),
              ),
            )
          }
          if (item[i]['ts-x']) {
            item[i]['ts-x'] = new Date(
              parseInt(
                item[i]['ts-x'].toString().substring(0, item[i]['ts-x'].toString().length - 3),
              ),
            )
          }
          if (item[i]['ts-sld']) {
            item[i]['ts-sld'] = new Date(
              parseInt(
                item[i]['ts-sld'].toString().substring(0, item[i]['ts-sld'].toString().length - 3),
              ),
            )
          }
        }
      }
      vm.items = result.results
    })
  }

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  load(1)

  vm.goMarket = function(id) {
    if (
      window.location.href.indexOf('dev') !== -1 ||
      window.location.href.indexOf('localhost') !== -1
    ) {
      window.open('https://market.streetteam.dev/listing/' + id, '_blank')
    } else {
      window.open('https://market.streetteam.net/listing/' + id, '_blank')
    }
  }

  vm.add = function() {
    vm.wash = {
      txt: '',
      ids: '',
      li: [],
    }
    $('#modalAddWashTrade').modal('show')
  }

  vm.create = function() {
    if (!vm.wash.txt) {
      swal('Please enter wash trade description', '', 'error')
      return
    }
    if (!vm.wash.ids) {
      swal('Please enter wash trade post ids', '', 'error')
      return
    }

    var ids = vm.wash.ids.trim().split(',')
    var li = []
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i].trim()
      if (id) {
        li.push({ 'id-p': parseInt(id) })
      }
    }
    vm.wash.li = li

    WashTradesService.save(vm.wash).then(
      function() {
        load(1)
        reloadPagination()

        $('#modalAddWashTrade').modal('hide')
      },
      function(err) {
        if (err && err.error) {
          swal(err.error.message, '', 'error')
        } else {
          swal('Some post id does not exist.', '', 'error')
        }
      },
    )
  }
}
